import React, { useState, useEffect } from 'react'

import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';

import api from '../components/api';

import CombustaoEstacionaria from '../GHG/CombustaoEstacionaria'
import CombustaoMovel from '../GHG/CombustaoMovel'
import DeslocamentoCasaTrabalho1 from '../GHG/DeslocamentoCasaTrabalho1'
import DeslocamentoCasaTrabalho2 from '../GHG/DeslocamentoCasaTrabalho2'
import DeslocamentoCasaTrabalho3 from '../GHG/DeslocamentoCasaTrabalho3'
import DeslocamentoCasaTrabalho4 from '../GHG/DeslocamentoCasaTrabalho4'
import Efluentes from '../GHG/Efluentes'
import EfluentesOperacao from '../GHG/EfluentesOperacao'
import EmissoesFugitivas1 from '../GHG/EmissoesFugitivas1'
import EmissoesFugitivas2 from '../GHG/EmissoesFugitivas2'
import EnergiaEletricaCompra from '../GHG/EnergiaEletricaCompra'
import EnergiaEletricaLocalizacao1 from '../GHG/EnergiaEletricaLocalizacao1'
import EnergiaEletricaLocalizacao2 from '../GHG/EnergiaEletricaLocalizacao2'
import EnergiaEletricaLocalizacao3 from '../GHG/EnergiaEletricaLocalizacao3'
import ResiduosSolidos1 from '../GHG/ResiduosSolidos1'
import ResiduosSolidos2 from '../GHG/ResiduosSolidos2'
import ResiduosSolidosOperacao1 from '../GHG/ResiduosSolidosOperacao1'
import ResiduosSolidosOperacao2 from '../GHG/ResiduosSolidosOperacao2'
import TransporteDistribuicao from '../GHG/TransporteDistribuicao'
import ViagensNegocios1 from '../GHG/ViagensNegocios1'
import ViagensNegocios2 from '../GHG/ViagensNegocios2'


const Modal = (props) => {


    var ano = props.ano
    var adesao_institucional_id = props.adesao_institucional_id

    var [cnpj, setCNPJ] = useState()
    var [nomeFantasia, setNomeFantasia] = useState()
    var [razaoSocial, setRazaoSocial] = useState()
    var [nomeArquivo, setNomeArquivo] = useState()



    async function carregaInfo() {

        await api.get(`desafioClimaPlanilha/${adesao_institucional_id}/${ano}`).then((result) => {
            //console.log(result.data, '!!')
    
            var data = result.data[0]
            //console.log(data)
            
            setCNPJ(data.cnpj)
            setRazaoSocial(data.razao_social)
            setNomeFantasia(data.nome_fantasia)
            setNomeArquivo(data.nomeArquivo)

        }).catch((err) => {

            console.log(err)

        })

    }


    function downloadPlanilhaGHG() {


        if (nomeArquivo) {


            window.location.href = `https://cdn.hospitaissaudaveis.org/uploads/desafioClima/${nomeArquivo}`


        }



    }


    useEffect(() => {

        carregaInfo()

    }, [adesao_institucional_id, ano])


    return (

        <div>


                <div className="modal fade" id="modalPlanilhaGHG" tabindex="-1" role="dialog">
                    <div className="modal-dialog modal-lg" role="document"  style={{ width: '100%'}}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Planilha GHG - Ano {ano}</h1>
                            </div>
                            <div class="modal-body">
                                
                                <div class="panel-body">


                                    <div class="row">

                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label>CNPJ</label>
                                            <input class="form-control" placeholder="" value={cnpj}  disabled />
                                                
                                                            
                                        </div>
                                    </div>

                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label>Razão Social</label>
                                            <input class="form-control" placeholder="" value={razaoSocial}  disabled />
                                                
                                                            
                                        </div>
                                    </div>
                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label>Nome fantasia</label>
                                            <input class="form-control" placeholder="" value={nomeFantasia}  disabled />
                                                
                                                            
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Arquivo</label>
                                            <input class="form-control" placeholder="" value={nomeArquivo}  readOnly style={{ cursor: 'pointer', backgroundColor: '#ceebc5'}} onClick={() => downloadPlanilhaGHG()} />
                                                
                                                            
                                        </div>
                                    </div>
                                    

                                        
                                        <div class="col-sm-12">



                                        <Accordion defaultActiveKey="0" flush>
                                            <Accordion.Item eventKey="0">
                                                
                                                <Accordion.Header>Combustao Estacionaria</Accordion.Header>
                                                
                                                <Accordion.Body>
                                                
                                                    <CombustaoEstacionaria ano={ano} adesao_institucional_id={adesao_institucional_id} />
                                                
                                                </Accordion.Body>
                                                
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="1">
                                                <Accordion.Header>Combustao Movel</Accordion.Header>
                                                <Accordion.Body>
                                                
                                                    <CombustaoMovel ano={ano} adesao_institucional_id={adesao_institucional_id} />

                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="2">
                                                <Accordion.Header>Deslocamento Casa Trabalho #1</Accordion.Header>
                                                <Accordion.Body>
                                                
                                                    <DeslocamentoCasaTrabalho1 ano={ano} adesao_institucional_id={adesao_institucional_id} />

                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="3">
                                                <Accordion.Header>Deslocamento Casa Trabalho #2</Accordion.Header>
                                                <Accordion.Body>
                                                
                                                <DeslocamentoCasaTrabalho2 ano={ano} adesao_institucional_id={adesao_institucional_id} />

                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="4">
                                                <Accordion.Header>Deslocamento Casa Trabalho #3</Accordion.Header>
                                                <Accordion.Body>
                                                
                                                    <DeslocamentoCasaTrabalho3 ano={ano} adesao_institucional_id={adesao_institucional_id} />

                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="5">
                                                <Accordion.Header>Deslocamento Casa Trabalho #4</Accordion.Header>
                                                <Accordion.Body>
                                                
                                                    <DeslocamentoCasaTrabalho4 ano={ano} adesao_institucional_id={adesao_institucional_id} />

                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="6">
                                                <Accordion.Header>Efluentes</Accordion.Header>
                                                <Accordion.Body>
                                                
                                                <Efluentes ano={ano} adesao_institucional_id={adesao_institucional_id} />

                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="7">
                                                <Accordion.Header>Efluentes Operacao</Accordion.Header>
                                                <Accordion.Body>
                                                
                                                
                                                    <EfluentesOperacao ano={ano} adesao_institucional_id={adesao_institucional_id} />

                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="8">
                                                <Accordion.Header>Emissoes Fugitivas #1</Accordion.Header>
                                                <Accordion.Body>
                                                
                                                <EmissoesFugitivas1 ano={ano} adesao_institucional_id={adesao_institucional_id} />

                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="9">
                                                <Accordion.Header>Emissoes Fugitivas #2</Accordion.Header>
                                                <Accordion.Body>
                                                
                                                    <EmissoesFugitivas2 ano={ano} adesao_institucional_id={adesao_institucional_id} />

                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="10">
                                                <Accordion.Header>Energia Eletrica Compra</Accordion.Header>
                                                <Accordion.Body>
                                                
                                                    <EnergiaEletricaCompra ano={ano} adesao_institucional_id={adesao_institucional_id} />

                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="11">
                                                <Accordion.Header>Energia Eletrica Localizacao #1</Accordion.Header>
                                                <Accordion.Body>
                                                
                                                    <EnergiaEletricaLocalizacao1 ano={ano} adesao_institucional_id={adesao_institucional_id} />

                                                </Accordion.Body>
                                            </Accordion.Item>


                                            <Accordion.Item eventKey="12">
                                                <Accordion.Header>Energia Eletrica Localizacao #2</Accordion.Header>
                                                <Accordion.Body>
                                                
                                                    <EnergiaEletricaLocalizacao2 ano={ano} adesao_institucional_id={adesao_institucional_id} />

                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="13">
                                                <Accordion.Header>Energia Eletrica Localizacao #3</Accordion.Header>
                                                <Accordion.Body>
                                                
                                                    <EnergiaEletricaLocalizacao3 ano={ano} adesao_institucional_id={adesao_institucional_id} />

                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="14">
                                                <Accordion.Header>Residuos Solidos #1</Accordion.Header>
                                                <Accordion.Body>
                                                
                                                    <ResiduosSolidos1 ano={ano} adesao_institucional_id={adesao_institucional_id} />

                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="15">
                                                <Accordion.Header>Residuos Solidos #2</Accordion.Header>
                                                <Accordion.Body>
                                                
                                                    <ResiduosSolidos2 ano={ano} adesao_institucional_id={adesao_institucional_id} />

                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="16">
                                                <Accordion.Header>Residuos Solidos Operacao #1</Accordion.Header>
                                                <Accordion.Body>
                                                
                                                
                                                    <ResiduosSolidosOperacao1 ano={ano} adesao_institucional_id={adesao_institucional_id} />

                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="17">
                                                <Accordion.Header>Residuos Solidos Operacao #2</Accordion.Header>
                                                <Accordion.Body>
                                                
                                                    <ResiduosSolidosOperacao2 ano={ano} adesao_institucional_id={adesao_institucional_id} />

                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="18">
                                                <Accordion.Header>Transporte Distribuicao</Accordion.Header>
                                                <Accordion.Body>
                                                
                                                <TransporteDistribuicao ano={ano} adesao_institucional_id={adesao_institucional_id} />

                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="19">
                                                <Accordion.Header>Viagens Negocios #1</Accordion.Header>
                                                <Accordion.Body>
                                                
                                                <ViagensNegocios1 ano={ano} adesao_institucional_id={adesao_institucional_id} />

                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="6">
                                                <Accordion.Header>Viagens Negocios #2</Accordion.Header>
                                                <Accordion.Body>
                                                
                                                <ViagensNegocios2 ano={ano} adesao_institucional_id={adesao_institucional_id} />

                                                </Accordion.Body>
                                            </Accordion.Item>


                                        </Accordion>
                                                


                                            
                                        </div>

                                    </div>

                                </div>


                        


                            </div>
                            <div className="modal-footer">


                                
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>

        

        </div>

    )

}

export default Modal